<template>
  <div class="AiCarouselVertical">
    <div
      :id="accessId"
      ref="container"
      class="AiCarouselVertical-container"
      aria-live="polite">
      <ai-carousel-slide
        v-for="(item, index) in items"
        :key="item.key"
        :item="item"
        :gutter="gutter"
        :current="currentStep === index + 1"
        :previous="currentStep === index + 2"
        :next="currentStep === index"
        vertical />
    </div>
  </div>
</template>

<script setup lang="ts">
import AiCarouselSlide from './AiCarouselSlide.vue';
import { useVerticalCarouselInteraction } from './hooks';
import type { AiCarouselItem } from './types';

interface Props {
  accessId?: string;
  items: AiCarouselItem[];
  modelValue: number;
  freeWheelFullScroll?: boolean;
  gutter?: number;
  height?: number;
  animation?: number;
}

interface Emits {
  (event: 'update:modelValue', value: number): void;
}

const props = withDefaults(defineProps<Props>(), {
  accessId: undefined,
  animation: 500,
  gutter: 48,
  height: 1,
});
const emits = defineEmits<Emits>();

const currentStep = computed({
  get() {
    return props.modelValue;
  },
  set(value: number) {
    emits('update:modelValue', value);
  },
});

const container = ref<HTMLElement>();
const gutter = computed(() => props.gutter);

useVerticalCarouselInteraction(container, currentStep, {
  animation: props.animation,
  collectionSize: props.items.length,
  freeWheelFullScroll: props.freeWheelFullScroll,
  gutter,
});
</script>

<style scoped lang="scss">
.AiCarouselVertical {
  position: relative;
  width: 100%;
}

.AiCarouselVertical-container {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  max-height: 50vh;
}
</style>
